import pdpHero from '@/modules/pdp-hero';

new pdpHero(
    document.querySelector('.js-pdp-hero')
);
